// extracted by mini-css-extract-plugin
module.exports = {"container":"SuperUserLink_container__1B2ua","icon":"SuperUserLink_icon__1hqOq","text":"SuperUserLink_text__Ip-Kd"};